<template>
  <div class="studentworkattendance_box">
    <div class="student_num">
      <el-progress type="circle" :stroke-width="12" :percentage="workNum.stuAttenceProbability"></el-progress>
      <div class="swa_box_r">
        <div class="swa_box_r_t">
          <p>
            当前考勤:
            <span>{{workNum.stuAttenceTotleNum}}</span>次
          </p>
        </div>
        <div class="swa_box_r_b">
          <p>
            暂未签到:
            <span>{{workNum.stuNotYetAttence}}</span>次
          </p>
          <p>
            已签到:
            <span>{{workNum.stuAttended}}</span>次
          </p>
          <p>
            缺勤:
            <span>{{workNum.stuAbsenteeism}}</span>次
          </p>
        </div>
      </div>
    </div>
    <div v-if="listState" class="student_list">
      <ul>
        <li v-for="(item,index) in studentList" :key="index">
          <p>{{item.date}}</p>
          <p>{{item.time}}</p>
          <p>
            <span v-if="item.classAttenceStateDto.state==-1" class="list_over"> <img src="../../../../../../static/images/yiwancheng.png" alt="">已结束</span>
            <span v-if="item.classAttenceStateDto.state==0" style="color:#FFB23C;"><img src="../../../../../../static/images/jinxingzhong.png" alt="">进行中</span>
            <span v-if="item.classAttenceStateDto.state==1" class="list_notStarted"><img src="../../../../../../static/images/weikaishi.png" alt="">未开始</span>
          </p>
          <div v-if="item.classAttenceStateDto.state==-1">
            <el-button type="info" class="absence" v-if="item.ifStuAttence==-1">缺勤</el-button>
            <el-button type="success" class="SignedIn" v-if="item.ifStuAttence==1">已签到</el-button>
          </div>
          <div v-if="item.classAttenceStateDto.state==0">
            <el-button
              v-if="item.ifStuAttence==-1"
              class="Signin"
              type="primary"
              @click="workAttendance(index)"
            >签到</el-button>
            <el-button v-if="item.ifStuAttence== 1" class="SignedIn" type="success">已签到</el-button>
          </div>
        </li>
      </ul>
       <el-pagination
          v-if="pageTotal.total>10"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageTotal.currentPage"
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageTotal.pageSize"
          :pager-count="5"
          layout="sizes, prev, pager, next"
          :total="pageTotal.total"
          class="paginator"
        ></el-pagination>
  </div>
    <div v-if="listState==false" class="null_box">
         <img src='../../../../../../static/images/wujieguo.png'>
         <p>暂无数据</p>
     </div>
     
    </div>
    
</template>

<script>
import * as api from "../../../../../api/workAttendanceApi";
export default {
  data() {
    return {
      studentList: [],
      pageTotal: {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      listState: false,
      courseData: [],
      userData: {
        userId: JSON.parse(sessionStorage.getItem("userId")),
        classId: this.$route.query.classId | 0,
        courseId: this.$route.query.id || 0,
      },
      workNum: {
        stuAttenceProbability: 0,
        stuAttenceTotleNum: 0,
        stuNotYetAttence: 0,
        stuAttended: 0,
        stuAbsenteeism: 0
      },
      studentList2: [] //备用的
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let url = `/${this.userData.courseId}/${this.userData.classId}/${this.pageTotal.currentPage}/${this.pageTotal.pageSize}`;
      api.getStudentAttenceList(url).then(res => {
        console.log(res);
        if (res.data.list.length!=0) {
          this.listState = true;
          this.studentList = res.data.list;
            this.pageTotal.total = res.data.total;
          this.studentList2 = JSON.parse(JSON.stringify(res.data.list));
          res.data.list.forEach((v, i) => {
            var s = v.classAttenceStateDto.staAttenceDetail.startTime.split(
              " "
            );
            var e = v.classAttenceStateDto.staAttenceDetail.endTime.split(" ");

            this.studentList[i].date = `${s[0]}`;
            this.studentList[i].time = `${s[1].slice(0,5)}-${e[1].slice(0,5)}`;
       
          });
        }else{
          console.log(res.data.list)
          this.listState = false;
          return
        }
      });
      let url2 = `/${this.userData.courseId}/${this.userData.classId}`;
      api.getStudentAttenceNum(url2).then(res => {
        console.log(res);
        this.workNum = res.data;
      });
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      let url = `/${this.userData.courseId}/${this.userData.classId}/${this.pageTotal.currentPage}/${this.pageTotal.pageSize}`;
      api.getStudentAttenceList(url).then(res => {
        console.log(res);
        if (res.data.list.length!=0) {
          this.listState = true;
          this.studentList = res.data.list;
            this.pageTotal.total = res.data.total;
          this.studentList2 = JSON.parse(JSON.stringify(res.data.list));
          res.data.list.forEach((v, i) => {
            var s = v.classAttenceStateDto.staAttenceDetail.startTime.split(
              " "
            );
            var e = v.classAttenceStateDto.staAttenceDetail.endTime.split(" ");

            this.studentList[i].date = `${s[0]}`;
            this.studentList[i].time = `${s[1].slice(0,5)}-${e[1].slice(0,5)}`;
       
          });
        }else{
          this.listState = false;
          return
        }
      });
    },
    handleSizeChange(val) {
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      //   this.getListData();
      this.handleCurrentChange(1)
      console.log(val);
    },
    workAttendance(i) {
      let url = `/${this.userData.courseId}/${this.userData.classId}`;
      let obj = this.studentList2[i];
      api.studentAttence(url, obj).then(res => {
        this.getList();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
}

.studentworkattendance_box {
  // min-width: 1334px;
  // height: calc(100% - 32px);
  height: 100%;

  background: #f4f4f4;

  // height: calc(100% - 137px);

  .student_num {
    display: flex;
    padding: 12px 0 13px 21px;
    // min-width: 1311px;
    // height: calc(100% - 137px);

    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 4px;
    /deep/ .el-progress {
      width: 80px;
      height: 80px;
      div,
      svg {
        width: 80px;
        height: 80px;
      }
      .el-progress__text {
        margin-top: 32px;
      }
    }
    .swa_box_r {
      width: 100%;
      .swa_box_r_t {
        width: 100%;
        p {
          font-weight: 900;
          font-size: 16px;

          span {
            display: inline-block;
            width: 34px;
            color: rgba(83, 151, 247, 1);

            text-align: right;
            margin-right: 8px;
          }
        }
      }
      & > div {
        display: flex;
        // min-width: 1053px;
        line-height: 40px;
        margin-left: 3.37%;
        font-size: 16px;

        p {
          width: 137px;
          color: #666666;
        }

        p:nth-of-type(2) {
          margin-left: 10.2%;
        }
        p:nth-of-type(3) {
          margin-left: 9.74%;
        }
        span {
          display: inline-block;
          width: 34px;
          
          color: rgba(83, 151, 247, 1);

          text-align: right;
          margin-right: 8px;
        }
      }
    }
  }

  .student_list {
    height: calc(100% - 180px);
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    margin-top: 16px;
    padding: 20px 30px 20px 20px;
    border-radius: 4px;
    
    // overflow-y: scroll;

    ul {
      //   height: 2000px;
      height: calc(100% - 60px);
        overflow-y: auto;
      li {
        display: flex;
        height: 48px;
        margin-bottom: 8px;
        border: 1px solid rgba(230, 230, 230, 1);
        line-height: 48px;
        font-size: 14px;
        position: relative;
        p:nth-of-type(1) {
          margin-left: 1.9%;
          font-weight: bolder;
        }
        p:nth-of-type(2) {
          margin-left: 9.7%;
          font-weight: 400;
        }
        p:nth-of-type(3) {
          margin-left: 12.6%;
          font-size: 12px;
          span{
          
            display: flex;
            align-items: center;
          }
          img{
            // margin-top: 5px;
            width: 16px;
            height: 16px;
            margin-right: 5px;
          
          }
          .list_over {
             color: #5397f7;
          }
          
          .list_notStarted {        
            color: #ff785a;
          }
        }
        & > div {
          position: absolute;
          right: 2.1%;
          // margin-left: 45.2%;
        }
        /deep/ .Signin {
          color: white;
          background: #5397f7;
           border: none;
        }
        /deep/ .absence {
          color: white;
          background: #cccccc;
           border: none;
        }
        /deep/ .SignedIn {
          color: white;
          background: #34d3b0;
           border: none;
        }
        
      }
    }
  }
  // .pagintaion_box{
  //   overflow: hidden;
  //   zoom: 1;
  //   &>div{
  //     float: right;
  //     margin-right: 25px;
  //   }
  //   margin-top: 10%;
  //     /deep/ .el-input{
  //   margin-top: -5px;
  // }
  // }
  /deep/ .el-button {
    width: 96px;
    height: 34px;
  }
  .null_box{
    height: 100%;
    background: white;
    padding-top: 100px;
    text-align: center;
    p{
      color: #999999;
    }
    img{
      margin: 0 auto;
    }
    
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/workAttendance/studentWorkAttendance.vue